module.exports = __webpack_public_path__ + "img/Map_1__Third_Canal.d076e8fd.jpg";